export default "__VITE_ASSET__CUsTc02D__"